
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from './Component/Footer'

import Home from './Pages/Home'
import About from './Pages/about'
import OurPatrons from './Pages/our-patron'
import AimsObject from './Pages/aims-objectives'
import Prayers from './Pages/prayers'

import SubjectExamination from './Pages/subject-examination'
import Cocurricular from './Pages/co-curricular'
import ExaminationPromo from './Pages/examination-promotion'
import Withdrawal from './Pages/withdrawal'
import HelpStudy from './Pages/help-study'
import TC from './Pages/Tc'

import CampusInformation from './Pages/campus-information'
import GernalInfo from './Pages/general-information'
import SchoolInformation from './Pages/school-information'

import Dicipline from './Pages/discipline'
import PaymentFee from './Pages/payment-fee'
import AdmissionRegulation from './Pages/admission-regulation'
import LeaveRules from './Pages/leave-rules'
import Uniform from './Pages/uniform'
import Library from './Pages/library'
import SchoolHours from './Pages/school-hour'

import ManagingCommitee from './Pages/managing-committee'
import OurManager from './Pages/our-managers'
import OurPrincipals from './Pages/our-principals'
import SchoolCabinet from './Pages/student-cabinets'
import SchoolStaff from './Pages/school-staff'
import SchoolManagement from './Pages/school-management'

import Chairman from './Pages/chairman'
import Manager from './Pages/manager'
import Principal from './Pages/principal'
import Headmistress from './Pages/headmistress'
import PresidentMessage from './Pages/president-message'

import Gallery from './Pages/Gallery'
import SubGallery from './Pages/SubGallery'
import VideoGallery from './Pages/VideoGallery'
import Magazine from './Pages/Magazine'
import VoiceMessage from './Pages/voice-message'

import ContactUs from './Pages/contact-us'
import CBSEDisclosure from './Pages/CBSE-disclosure'



import Syllabus from './Pages/syllabus'
import Events from './Pages/Events'
import News from './Pages/news'






// import ErpSoftware from './Pages/erp-software'
// import Fee from './Pages/fee'






function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-patron" element={<OurPatrons />} />
          <Route path="/aims-objectives" element={<AimsObject />} />
          <Route path="/prayers" element={<Prayers />} />

          <Route path="/subject-examination" element={<SubjectExamination />} />
          <Route path="/co-curricular" element={<Cocurricular />} />
          <Route path="/examination-promotion" element={<ExaminationPromo />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/help-study" element={<HelpStudy />} />
          <Route path="/Tc" element={<TC />} />

          <Route path="/campus-information" element={<CampusInformation />} />
          <Route path="/general-information" element={<GernalInfo />} />
          <Route path="/school-information" element={<SchoolInformation />} />

          <Route path="/dicipline" element={<Dicipline />} />
          <Route path="/payment-fee" element={<PaymentFee />} />
          <Route path="/admission-regulations" element={<AdmissionRegulation />} />
          <Route path="/leave-rules" element={<LeaveRules />} />
          <Route path="/uniform" element={<Uniform />} />
          <Route path="/library" element={<Library />} />
          <Route path="/school-hour" element={<SchoolHours />} />

          <Route path="/managing-committee" element={<ManagingCommitee />} />
          <Route path="/our-managers" element={<OurManager />} />
          <Route path="/our-principals" element={<OurPrincipals />} />
          <Route path="/student-cabinets" element={<SchoolCabinet />} />
          <Route path="/school-staff" element={<SchoolStaff />} />
          <Route path="/school-management" element={<SchoolManagement />} />

          <Route path="/chairman" element={<Chairman />} />
          <Route path="/manager" element={<Manager />} />
          <Route path="/principal" element={<Principal />} />
          <Route path="/headmistress" element={<Headmistress />} />
          <Route path="/president-message" element={<PresidentMessage />} />


          <Route path="/gallery" element={<Gallery />} />
          <Route path="/subgallery" element={<SubGallery />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
          <Route path="/Magazine" element={<Magazine />} />
          <Route path="/voice-message" element={<VoiceMessage />} />


          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/CBSE-disclosure" element={<CBSEDisclosure />} />
          <Route path="/syllabus" element={<Syllabus />} />

          <Route path="/events" element={<Events />} />
          <Route path="/news" element={<News />} />





          {/* <Route path="/erp-software" element={<ErpSoftware />} /> */}
          {/* <Route path="/fee" element={<Fee />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App;
